import React, { useState, useEffect } from "react";
import DASHBOARD_API from "../../../../apis/dashboard.api";
import { DivorceDisplayCardListing } from "./components/DivorceDisplayCardListing";
import { DivorceCheckList } from "./components/DivorceCheckList";
import { DivorceDocumnetCard } from "./components/DivorceDocumnetCard";
import { DivorceContactCard } from "./components/DivorceContactCard";
import { DivorceInsuranceCard } from "./components/DivorceInsuranceCard";
import DivorcePlanCalander from "./components/DivorcePlanCalander";
import FETCH from "../../../../utils/fetch";
import { MODULE_API } from "../../../../apis";
import { DivorceBudget } from "./components/DivorceBudget";
import ModalVideo from "../../../../newComponents/ModuleVideos/ModalVideo";

export const DivorceDashboard = () => {
  const [tableData, setTableData] = useState({});
  const [loading, setLoading] = useState(false);
  const [insuranceData, setInsuranceData] = useState([]);
  const [monetaryValue, setMonetaryValue] = useState(0);
  const [calanderData, setCalanderData] = useState([]);

  const [totalLoan, setTotalLoan] = useState(0);
  const [fileUpload, setFileUpload] = useState({
    createdAt: "2025-03-28T10:41:53.000Z",
    "Document Upload":
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/81a1f8e1-4c40-430e-b629-6ef833763e65.xlsx",
    "Uploaded File Name": "Disability Updates (2).xlsx",
  });
  const cardMessages = {
    "Personal Information": {
      name: "Personal Information",
      Purpose:
        "Captures essential identity details, contact information, and family structure needed for legal proceedings, court documents, and establishing custody arrangements.",
      tooltip: "Divorce_Personal_Information"
    },
    "Insurance Coverage": {
      name: "Insurance Coverage",
      Purpose:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
      tooltip: "Divorce_Insurance_Coverage",
    },
    "Debt & Liabilities": {
      name: "Debt & Liabilities",
      Purpose:
        "Documents all marital and individual debts to determine responsibility for payment after divorce. Critical for protecting credit scores and ensuring fair distribution of financial obligations.",
      tooltip: "Divorce_Debt_Liabilities",
    },
    "Asset Documentation": {
      name: "Asset Documentation",
      Purpose:
        "Inventories and documents all marital and separate property to ensure proper asset division and valuation during divorce negotiations.",
      tooltip: "Divorce_Asset_Documentation",
    },
    "Checklist/Tasks": {
      name: "Checklist/Tasks",
      Purpose:
        "Tracks important divorce-related tasks, deadlines, and milestones to ensure nothing is overlooked during the complex legal process. Helps maintain organization and progress toward divorce completion.",
      tooltip: "",
    },
    "Income Information": {
      name: "Income Information",
      Purpose:
        "Records all income sources for both spouses to calculate support obligations, determine financial capacity, and establish post-divorce budgets.",
      tooltip: "Divorce_Income_Information",
    },
    "Child Custody Considerations": {
      name: "Child Custody Considerations",
      detailsHeading: "Visitation Schedule",
      Purpose:
        "Plans parenting arrangements, visitation schedules, and decision-making responsibilities to protect children's best interests during and after divorce.",
      tooltip: "Divorce_Child_Custody_Considerations",
    },
    "Legal Documentations": {
      name: "Legal Documentations",
      Purpose:
        "Organizes critical legal papers and court documents required for divorce proceedings and establishing new legal arrangements.",
      tooltip: "Divorce_Legal_Documentation",
    },
    "Child Support Calculations": {
      name: "Child Support Calculations",
      Purpose:
        "Computes financial support obligations based on income, custody arrangements, and children's needs to ensure proper support.",
      tooltip: "Divorce_Support_Calculations",
    },
    "Business Interests": {
      name: "Business Interests",
      Purpose:
        "Documents business ownership, valuations, and operations that may need division or consideration in divorce settlements.",
      tooltip: "Divorce_Business_Interests",
    },
    "Professional Contacts": {
      name: "Professional Contacts",
      Purpose:
        "Maintains contact information for attorneys, mediators, financial advisors, and other professionals needed throughout the divorce process.",
      tooltip: "Divorce_Professional_Team",

    },
  };
  const getInsuranceList = async () => {
    try {
      setLoading(true);
      const userRole =
      localStorage.getItem("role") != "undefined" &&
      JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
         id: userRole === "Financial Advisor Client"
            ? `?module=Insurance Products V2&page=1&limit=50&clientId=${ID}`
            : `?module=Insurance Products V2&page=1&limit=50`,
        body: {},
      });
      setLoading(false);
      if (datares && datares.records) {
        setInsuranceData(datares.records);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const moduleNames = [
    "Personal Information",
    "Liability",
    "Asset",
    "Income",
    "Child Custody Considerations",
    "Business Interests",
    "Professional Team",
    "Legal Documentation",
    "Support Calculations",
  ];

  const fetchAllModulesData = async () => {
    try {
      setLoading(true);
      const results = await Promise.all(
        moduleNames.map((name) => fetchData(name))
      );
      console.log("All module results:", results);
      const primaryCaresGiverMod = results.find(
        (item) => item.moduleName === "Primary Caregivers"
      );
      if (primaryCaresGiverMod) {
        const targetRecord = primaryCaresGiverMod.records.find(
          (record) =>
            record.subType === "Disability" ||
            "Professional Care Provider" in record
        );
        // setFieldsData(targetRecord);
      } else {
        console.log("Medical History module not found");
      }

      const tableDataObj = results.reduce((acc, { moduleName, records }) => {
        acc[formatModuleKey(moduleName)] = records;
        return acc;
      }, {});

      setTableData(tableDataObj);
    } catch (error) {
      console.error("Error fetching all modules:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchData = async (moduleName) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      const records = res.records || [];
      setLoading(false);
      return { moduleName, records }; // Return object with moduleName to map later
    } catch (error) {
      console.error(`Error fetching data for ${moduleName}:`, error);
      return { moduleName, records: [] }; // Return empty if failed
    } finally {
      setLoading(false);
    }
  };
  const formatModuleKey = (moduleName) => {
    return (
      moduleName &&
      moduleName
        .replace(/[^a-zA-Z ]/g, "") // Remove special chars
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
          index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, "") + "Data"
    );
  };
  const getAll = async () => {
    await fetchAllModulesData();
    await getInsuranceList();
    // await getLiabilitySum();
    // await getMonetaryValueAssets();
  };
  useEffect(() => {
    getAll();
  }, []);

  console.log("taabababababa",tableData,)

  return (
    <div>
      <div className="MainDisabilityDashboard">
        <ModalVideo module="Divorce" autoOpen={true} />
        <div className="mainUpperContainer">
          <div className="divorce-main-cards-container-innner">
            <div style={{ width: "70%" }}>
              <div
                className="main-disaster-cards-style"
                style={{ marginBottom: "0.8rem" }}
              >
                <DivorceDisplayCardListing
                  step={0}
                  moduleData={cardMessages["Personal Information"]}
                  documents={
                    tableData &&
                    tableData.personalInformationData &&
                    tableData.personalInformationData
                  }
                  fileUpload={fileUpload}
                  loading={loading}
                  width="50%"
                />

                <DivorceDisplayCardListing
                  step={3}
                  moduleData={cardMessages["Debt & Liabilities"]}
                  documents={
                    tableData &&
                    tableData.liabilityData &&
                    tableData.liabilityData
                  }
                  fileUpload={fileUpload}
                  loading={loading}
                  width="50%"
                />
              </div>
              <div className="main-disaster-cards-style">
                <DivorceDisplayCardListing
                  step={1}
                  moduleData={cardMessages["Asset Documentation"]}
                  documents={
                    tableData &&
                    tableData.assetData &&
                    tableData.assetData
                  }
                  fileUpload={fileUpload}
                  loading={loading}
                  width="50%"
                />
                <DivorceDisplayCardListing
                  step={2}
                  moduleData={cardMessages["Income Information"]}
                  documents={
                    tableData &&
                    tableData.incomeData &&
                    tableData.incomeData
                  }
                  fileUpload={fileUpload}
                  loading={loading}
                  width="50%"
                />
              </div>
            </div>
            <div style={{ width: "30%" }}>
              <DivorceCheckList
                step={4}
                moduleData={cardMessages["Checklist/Tasks"]}
                documents={
                  tableData &&
                  tableData.personalInformationData &&
                  tableData.personalInformationData
                }
                fileUpload={fileUpload}
                loading={loading}
                width="100%"
              />
            </div>
          </div>
          <div style={{ width: "30%" }}>
            <DivorcePlanCalander calanderData={calanderData} />
          </div>
        </div>
        <div className="mainUpperContainer">
          <div style={{ width: "70%" }}>
            <div className="main-disaster-cards-style">
              <div className="DisabilityInsuarceCardMain">
                <DivorceInsuranceCard
                  dataList={insuranceData}
                  step={5}
                  moduleData={cardMessages["Insurance Coverage"]}
                  loading={loading}
                />
              </div>
              <DivorceDisplayCardListing
                step={7}
                loading={loading}
                moduleData={cardMessages["Child Custody Considerations"]}
                documents={
                  tableData && tableData.childCustodyConsiderationsData
                    ? tableData.childCustodyConsiderationsData
                    : []
                }
                width="33%"
              />
            </div>
          </div>
          <div style={{ width: "30%" }}>
            {" "}
            <DivorceDocumnetCard
              step={6}
              loading={loading}
              moduleData={cardMessages["Legal Documentations"]}
              dataList={
                tableData && tableData.recoveryPlanData
                  ? tableData.recoveryPlanData
                  : []
              }
              width="100%"
            />
          </div>
        </div>
        <div className="mainUpperContainer">
          <div style={{ width: "70%" }}>
            <div
              className="main-disaster-cards-style"
              style={{ height: "100%" }}
            >
              <DivorceDisplayCardListing
                step={8}
                loading={loading}
                moduleData={cardMessages["Business Interests"]}
                dataList={
                  tableData && tableData.businessInterestsData
                    ? tableData.businessInterestsData
                    : []
                }
                width="33%"
              />
              <DivorceDisplayCardListing
                step={9}
                loading={loading}
                moduleData={cardMessages["Child Support Calculations"]}
                documents={
                  tableData && tableData.supportCalculationsData
                    ? tableData.supportCalculationsData
                    : []
                }
                width="66%"
                height="100%"
              />
            </div>
          </div>
          <div style={{ width: "30%" }}>
            {" "}
            <DivorceContactCard
              step={10}
              loading={loading}
              moduleData={cardMessages["Professional Contacts"]}
              documents={
                tableData && tableData.professionalTeamData
                  ? tableData.professionalTeamData
                  : []
              }
              width="100%"
            />
          </div>
        </div>
        <div className="mainUpperContainer">
          <DivorceBudget loading={loading} />
        </div>
      </div>
    </div>
  );
};
